/**
 * Popup identifiers for tracking which popups have been shown to users.
 * Must match the PHP enum App\Service\Onboarding\PopupID.
 */
export enum EPopupID {
  PREMIUM = "premium",
  FREEMIUM = "freemium",
}
